import { Map, fromJS } from 'immutable';
import TeamInfoConstants from '../constants/TeamInfo.constants';

const initialState = Map({
  [TeamInfoConstants.State.TEAM_INFO_BY_WORKSPACE_SLUG]: Map({}),
  [TeamInfoConstants.State.LOADING]: false,
  [TeamInfoConstants.State.ERROR]: null,
});

export const TeamInfo = (state = initialState, action) => {
  switch (action.type) {
    case TeamInfoConstants.Actions.FETCH_TEAM_INFO_REQUEST:
      return state.set(TeamInfoConstants.State.LOADING, true).set(TeamInfoConstants.State.ERROR, null);

    case TeamInfoConstants.Actions.FETCH_TEAM_INFO_SUCCESS: {
      const { workspaceSlug, ...teamData } = action.payload;
      return state
        .setIn([TeamInfoConstants.State.TEAM_INFO_BY_WORKSPACE_SLUG, workspaceSlug], fromJS(teamData))
        .set(TeamInfoConstants.State.LOADING, false)
        .set(TeamInfoConstants.State.ERROR, null);
    }

    case TeamInfoConstants.Actions.FETCH_TEAM_INFO_FAILURE:
      return state.set(TeamInfoConstants.State.LOADING, false).set(TeamInfoConstants.State.ERROR, action.payload);

    case TeamInfoConstants.Actions.CLEAR_TEAM_INFO: {
      const { workspaceSlug } = action.payload;
      return state.deleteIn([TeamInfoConstants.State.TEAM_INFO_BY_WORKSPACE_SLUG, workspaceSlug]);
    }

    default:
      return state;
  }
};
